import { render, staticRenderFns } from "./PDFOneCamEmployeeSalary.vue?vue&type=template&id=48c6e5ee&scoped=true"
import script from "./PDFOneCamEmployeeSalary.vue?vue&type=script&lang=js"
export * from "./PDFOneCamEmployeeSalary.vue?vue&type=script&lang=js"
import style0 from "./PDFOneCamEmployeeSalary.vue?vue&type=style&index=0&id=48c6e5ee&lang=scss"
import style1 from "./PDFOneCamEmployeeSalary.vue?vue&type=style&index=1&id=48c6e5ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c6e5ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c6e5ee')) {
      api.createRecord('48c6e5ee', component.options)
    } else {
      api.reload('48c6e5ee', component.options)
    }
    module.hot.accept("./PDFOneCamEmployeeSalary.vue?vue&type=template&id=48c6e5ee&scoped=true", function () {
      api.rerender('48c6e5ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeSalary/printPayment/PDFOneCamEmployeeSalary.vue"
export default component.exports